var module = angular.module('octopusApp.dashboard', []);

module.config(function($stateProvider, $urlRouterProvider) {

    $stateProvider.state('app.dashboard',  {
        url: '/',
        templateUrl: 'areas/dashboard/views/dashboard.html',
        controller: 'DashboardController',
        layout: {
            title: 'Dashboard',
            tab: 'dashboard'
        }
    });

    $urlRouterProvider.when('', function ($state) {
        $state.go('app.dashboard');
    });


    $stateProvider.state('app.dashboard-configure',  {
        url: '^/dashboard/configure',
        templateUrl: 'areas/dashboard/views/dashboard_configure.html',
        controller: 'DashboardConfigureController',
        layout: {
            title: 'Dashboard Configuration',
            tab: 'dashboard'
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/dashboard/dashboard_module.js
// module id = 130
// module chunks = 1